import { ChevronRight } from "lucide-react";
import { features } from "@/content/explordioCopy";

export const FeatureGrid = ({ onFeatureOpen }) => (
  <section className="features-section" aria-label="Explordio features" data-testid="features-section">
    <div className="site-shell feature-grid" data-testid="feature-grid">
      {features.map((feature) => {
        return (
          <button className="feature-card" key={feature.id} type="button" onClick={() => onFeatureOpen(feature)} data-testid={`feature-tile-${feature.id}`}>
            <img className="feature-icon" src={`/assets/feature-icons/${feature.id}.png`} alt="" aria-hidden="true" data-testid={`feature-icon-${feature.id}`} />
            <h2 className="feature-title" data-testid={`feature-title-${feature.id}`}>{feature.title}</h2>
            <p className="feature-description" data-testid={`feature-description-${feature.id}`}>{feature.description}</p>
            <span className="feature-arrow" aria-hidden="true"><ChevronRight size={19} /></span>
          </button>
        );
      })}
    </div>
  </section>
);